(function Gallery(namespace) {
  'use strict';
  
  var support = POV.support;
  var elements = getElements();
  var observer;

  var isFirstTouch = true;
  var initialX, initialY, lastX, initialTime;

  var publicAPI = {
    goToPosition: goToPosition,
    goToId: goToId,
    refresh: refresh,
    removeSlideByPosition: removeSlideByPosition
  };

  namespace.Gallery = publicAPI;

  (support.IntersectionObserver) ? initObserver() : initScrollObserver();
  initEvents();

  POV.emit('gallery:init', POV.Gallery);

  function refresh() {
    elements = getElements();
  }

  function removeSlideByPosition(position) {
    var index = position - 1;
    var imageNode =  elements.items[index];
    var thumbNode = elements.thumbs[index];

    if (thumbNode.hasAttribute('data-active')) {
      console.error("POV.Gallery can't remove active slide");
      return;
    }

    if (!imageNode || !thumbNode) {
      console.error("POV.Gallery can't find slide");
      return;
    }

    imageNode.parentElement.removeChild(imageNode);
    thumbNode.parentElement.removeChild(thumbNode);

    elements = getElements();

    elements.thumbs.forEach(function(thumbNode, index){
      thumbNode.setAttribute('data-index', index + 1);
    });

    elements.items.forEach(function(itemNode, index){
      itemNode.setAttribute('data-index', index + 1);
    });
  }

  function initObserver() {
    observer = new IntersectionObserver(
      observerCallback,
      {
        root: elements.container,
        rootMargin: '1px',
        threshold: [0.0, 1.0]
      }
    );
  }
  
  function initScrollObserver() {
    var scrollTimer;

    elements.container.addEventListener('scroll', function() {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(refresh , 150);
    }, false);
    
    var refresh = function() { 
      scrollEnd(getVisibileItem());
    };
  }
  
  function initEvents() {
    elements.items.forEach(itemEvents);
    elements.thumbs.forEach(thumbEvents);
    elements.triggers.forEach(triggerEvents);
    elements.videos.forEach(videoEvents);

    if (elements.thumbBtn) elements.thumbBtn.addEventListener('click', thumbBtnClick.bind(null, elements.thumbBtn), false);
    window.addEventListener('resize', resizeThrottler, false);

    function itemEvents(item) {
      if (!support.SnapPoints) {
        item.addEventListener('touchstart', touchstart, support.EventListenerOptions ? { passive: true } : false);
        item.addEventListener('touchmove', touchmove, support.EventListenerOptions ? { passive: true } : false);
      }

      if (support.IntersectionObserver) observer.observe(item);
    }

    function thumbEvents(thumb) {
      thumb.addEventListener('click', thumbClick.bind(null, thumb), false);
    }

    function triggerEvents(trigger) {
      trigger.addEventListener('click', triggerClick.bind(null, trigger), false);
    }

    function videoEvents(video) {
      if (support.IntersectionObserver) observer.observe(video);
    }
  }
  
  function touchstart(evt) {
    var touch = head(evt.touches);
    initialX = touch.clientX;
    initialY = touch.clientY;
    lastX = initialX;
  }
  
  function touchmove(evt) {
    if (!initialTime) initialTime = evt.timeStamp;
    
    var touch = head(evt.touches);
    var item = evt.target.parentElement;
    var x = touch.clientX - initialX;
    var y = touch.clientY - initialY;
    var time = evt.timeStamp - initialTime;
    var direction;
    
    if (Math.abs(y) > Math.abs(x)) {
      // Scroll Y
      initialTime = time;
      return;
    }
    
    if (x < 0) direction = 'right';
    if (x > 0) direction = 'left';
    
    lastX = touch.clientX;
    
    if (time > 500 || isFirstTouch) {
      isFirstTouch = false;
      initialTime = 0;
      setScroll(item, direction);
    }
  }
  
  function setScroll(item, direction) {
    var scrollX = (direction === 'right')
    ? elements.container.scrollLeft + item.offsetWidth
    : elements.container.scrollLeft - item.offsetWidth;
    
    elements.container.scrollLeft = scrollX;
  }
  
  function triggerClick(trigger) {
    var index = getIndex();

    elements.container.style.scrollBehavior = 'smooth';
    elements.thumbsTrack.style.scrollBehavior = 'smooth';
    
    (trigger.getAttribute('aria-label') === 'Next')
    ? goTo(index + 1)
    : goTo(index - 1);
  }
  
  function thumbClick(thumb) {
    var index = getIndexFromElement(thumb);
    goTo(index);
  }
  
  function goToPosition(position) {
    var slide = elements.container.querySelector('[data-position="' + position + '"]');
    var index = getIndexFromElement(slide);
    goTo(index);
  }

  function goToId(imageId) {
    var slide = elements.container.querySelector('[data-id="' + imageId + '"]');
    if (!slide) return;
    var index = getIndexFromElement(slide);
    goTo(index);
  }
  
  function goTo(index){
    var item = elements.items[index];
    var itemWidth = item.offsetWidth;
    var scrollOffset = index * itemWidth;

    POV.emit('gallery:change:start', item);
    
    elements.container.scrollLeft = scrollOffset;

    if (!support.ScrollBehavior) {
      var lastSlide = elements.container.querySelector('.slideScroll');
      
      if (lastSlide) lastSlide.classList.remove('slideScroll');
      item.classList.add('slideScroll');
    }
  }
  
  function thumbBtnClick(){
    if (elements.thumbsWrap.hasAttribute('data-collapsed')) {
      elements.thumbBtn.setAttribute('aria-expanded', 'true');
      elements.thumbsWrap.removeAttribute('data-collapsed')
      elements.thumbsWrap.setAttribute('data-expanded', true);
      elements.thumbBtnText.textContent = 'View less';
    } else {
      elements.thumbBtn.setAttribute('aria-expanded', 'false');
      elements.thumbsWrap.removeAttribute('data-expanded')
      elements.thumbsWrap.setAttribute('data-collapsed', true);
      elements.thumbBtnText.textContent = 'View all';
    }
  }

  function observerCallback(IntersectionObserverEntry) {
    var intersecting = IntersectionObserverEntry.filter(function(entry) {
      return entry.intersectionRatio === 1;
    });

    handleVideoIntersection(IntersectionObserverEntry);

    if (intersecting.length) scrollEnd(head(intersecting).target);
  }

  function handleVideoIntersection(IntersectionObserverEntry) {
    IntersectionObserverEntry.forEach(function(entry) {
      if (entry.target.nodeName === 'VIDEO') {
        try {
          var video = entry.target;
          video.controls = true;
          if (videoIsPlaying(video)) video.pause();
        } catch(error) {
          console.log(error);
        }
      }
    });
  }

  function videoIsPlaying(video) {
    return (video.currentTime > 0 && !video.paused && !video.ended && video.readyState > 2);
  }
  
  function scrollEnd(item) {
    compose(setNavigationState, setThumbsState)(item);
    elements.container.style.scrollBehavior = 'unset';
    elements.thumbsTrack.style.scrollBehavior = 'unset';
    POV.emit('gallery:change:end', item);
  }
  
  function setNavigationState(item) {
    elements.triggerLeft.removeAttribute('disabled');
    elements.triggerRight.removeAttribute('disabled');
    
    if (item === head(elements.items)) {
      elements.triggerLeft.setAttribute('disabled', true);
    } else if (item === last(elements.items)) {
      elements.triggerRight.setAttribute('disabled', true);
    }

    return item;
  }

  function setThumbsState(item) {
    var position = item.getAttribute('data-index');
    var activeThumb = getThumbActive();
    var newActiveThumb = getThumbByPosition(position);

    activeThumb.removeAttribute('data-active');
    newActiveThumb.setAttribute('data-active', true);
    
    var trackBox = elements.thumbsTrack.getBoundingClientRect();
    var trackLeft = trackBox.left;
    var trackWidth = trackBox.width;
    
    var itemBox = newActiveThumb.getBoundingClientRect();
    var itemLeft = itemBox.left;
    var itemWidth = itemBox.width;
    
    elements.thumbsTrack.scrollLeft = elements.thumbsTrack.scrollLeft + itemLeft - trackWidth/2 + itemWidth/2 - trackLeft;

    return item;
  }

  function getThumbActive() {
    var thumbList = elements.thumbs.filter(
      function findThumbActive(thumb){
        return thumb.hasAttribute('data-active');
      }
    );

    return head(thumbList);
  }

  function getThumbByPosition(position) {
    var thumbList = elements.thumbs.filter(
      function findThumbByPos(thumb) {
        return Number(thumb.getAttribute('data-index')) === Number(position);
      }
    );

    return head(thumbList);
  }
  
  function getVisibileItem() {
    var index = getIndex();
    return elements.items[index];
  }
  
  function resizeThrottler() {
    var resizeTimeout;

    if (!resizeTimeout) {
      resizeTimeout = setTimeout(function() {
        resizeTimeout = null;
        thumbClick(getThumbActive());
      }, 66);
    }
  }

  function getIndex() {
    var scrollLeft = elements.container.scrollLeft;
    var itemWidth = head(elements.items).getBoundingClientRect().width;
    var index = Math.round(scrollLeft/itemWidth);

    return index;
  }

  function getIndexFromElement(element) {
    return Number(element.getAttribute('data-index')) - 1;
  }

  function getElements() {
    var container = document.getElementById('Gallery');
  
    return {
      container: container,
      items: nodeList('.slider__track--item', container),
      videos: nodeList('video', container),
      thumbsWrap: head(nodeList('#GalleryThumbs')),
      thumbsTrack: head(nodeList('#ThumbTrack')),
      thumbs: nodeList('#GalleryThumbs .thumb__item'),
      thumbBtn: head(nodeList('.btn-thumb')),
      thumbBtnText: nodeList('.btn-thumb-text'),
      triggers: nodeList('.product__gallery .gallery__btn'),
      triggerLeft: head(nodeList('.product__gallery .slider__btn--left')),
      triggerRight: head(nodeList('.product__gallery .slider__btn--right'))
    }
  }
  
})(window.POV || (window.POV = {}));